import React from "react";

import Navbar from "components/MI/Navbar";
import UserMenu from "components/layout/userMenuNew";
import { useRetornarUnidade } from "features/retornar-unidade/hooks/useRetornarUnidade";

import {
  Container,
  Header,
  Hr,
  Scrollbar,
  Title,
} from "./RetornarUnidadePage.styles";

const RetornarUnidadePage = (): JSX.Element => {
  const { stepContent } = useRetornarUnidade();

  return (
    <Navbar selected="retornar-unidade">
      <UserMenu />
      <Scrollbar>
        <Container>
          <Header>
            <Title>Retomar a titularidade da unidade</Title>
          </Header>

          <Hr />
          {stepContent}
        </Container>
      </Scrollbar>
    </Navbar>
  );
};

export default RetornarUnidadePage;
